var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDeletePhotoFilled = function SvgDeletePhotoFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 10H33.75C34.4414 10 35 10.5586 35 11.25V12.5C35 12.6719 34.8594 12.8125 34.6875 12.8125H32.3281L31.3633 33.2422C31.3008 34.5781 30.2031 35.625 28.8672 35.625H11.1328C9.80078 35.625 8.69922 34.5742 8.63672 33.2422L7.67187 12.8125H5.3125C5.14062 12.8125 5 12.6719 5 12.5V11.25C5 10.5586 5.55859 10 6.25 10Z",
    fill: "#DC2626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 6.875V8.66413H11.25V6.875C11.25 5.49609 12.3711 4.375 13.75 4.375H26.25C27.6289 4.375 28.75 5.49609 28.75 6.875Z",
    fill: "#DC2626"
  })));
};
export default SvgDeletePhotoFilled;